import { ISearchBoxStyleProps, ISearchBoxStyles } from '@fluentui/react';

export const SearchBoxStyles = (_props: ISearchBoxStyleProps): Partial<ISearchBoxStyles> => {
  return {
    root: {
      selectors: {
        '::after': {
          borderWidth: 1,
        },
      },
    },
  };
};
